<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <chart ref="chart"></chart>
    </div>
</template>

<script>
    import chart from './osmBarChart';
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "OsmStats",
        components: {LoadingComponent, chart},
        data() {
            return {
                loading: false
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get('statistics/osm')
                .then(res => this.$refs.chart.init(res.data.data))
                .catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        }
    }
</script>

<style scoped>

</style>